import React from "react";
import { DialogContent, DialogTitle, GridLegacy } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import FormV2 from "../JamezzForm/FormV2";
import FormFile from "../../components/Forms/FormFile";
import { useDialog } from "../../licensing/utils/DialogProvider";

const endPoint = "core/permissions/import";

function UploadPermissionsDialog(props) {
  const [, closeDialog] = useDialog();
  return (
    <>
      <DialogTitle>
        <TranslationWrapper tDefault={"Upload all permissions"} tKey={"uploadPermissionsDialog.title"} />
      </DialogTitle>
      <DialogContent>
        <FormV2
          afterSubmit={() => {
            closeDialog();
          }}
          endPoint={endPoint}
          getEditLink={() => {
            return null;
          }}
          isSaveButtonSticky={false}
        >
          <GridLegacy container spacing={1}>
            <FormFile
              name={"permissions"}
              permissionKey={null}
              rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
              tDefault={"Permissions File"}
              tKey={"Permissions File"}
            />
          </GridLegacy>
        </FormV2>
      </DialogContent>
    </>
  );
}

export default UploadPermissionsDialog;
